module.exports = __webpack_public_path__ + "static/media/tasks-grey.5b068ea3.svg";